import { Link } from "react-router-dom";
import { Show } from "@clerk/react";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "@/components/ui-nw/UserAvatar";
import { LANDING } from "@/constants/testIds";

import { StudioImage } from "@/components/ui-nw/StudioImage";

const joinRole = (role) => () => localStorage.setItem("nw_role", role);

export const Hero = () => (
  <section data-testid={LANDING.hero} className="relative -mx-4 sm:mx-0 overflow-hidden sm:rounded-3xl border-y sm:border border-white/10">
    <StudioImage name="hero-studio" eager sizes="(min-width: 1152px) 1152px, 100vw" alt="Producer at a mixing console in a red-lit recording studio" className="absolute inset-0 h-full w-full object-cover object-[70%_center] opacity-80" />
    <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(5,5,8,0.35)_0%,rgba(5,5,8,0.8)_55%,#050508_100%)] sm:bg-[linear-gradient(90deg,#050508_10%,rgba(5,5,8,0.75)_45%,rgba(5,5,8,0.15))]" />
    <div className="relative px-5 sm:px-10 pt-24 pb-10 sm:py-24 max-w-2xl space-y-6">
      <SectionLabel>AI Entertainment Network</SectionLabel>
      <h1 data-testid="landing-hero-headline" className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[1.02] tracking-tight">
        <span className="chrome-text">Your vision.</span><br />
        <span className="chrome-text">Your voice.</span><br />
        <span className="text-nw-red drop-shadow-[0_0_25px_rgba(255,30,39,0.45)]">Your wave.</span>
      </h1>
      <p data-testid="landing-hero-text" className="text-sm sm:text-base leading-relaxed text-slate-300 max-w-lg">
        A new home for AI-powered creativity. Create your sound. Tell your story. Share your vision. Get heard.
      </p>
      <Show when="signed-out">
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <Link to="/sign-up" onClick={joinRole("creator")} data-testid={LANDING.joinCreator} className="btn-red px-6 py-3.5 text-sm inline-flex items-center justify-center gap-2">
            Join as Creator <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to="/sign-up" onClick={joinRole("fan")} data-testid={LANDING.joinFan} className="btn-chrome px-6 py-3.5 text-sm text-center">Join free as Fan</Link>
        </div>
      </Show>
      <Show when="signed-in">
        <Link to="/music" data-testid={LANDING.exploreMusic} className="btn-red inline-flex px-6 py-3.5 text-sm items-center gap-2">Explore music <ArrowRight className="h-4 w-4" /></Link>
      </Show>
    </div>
  </section>
);
